module.exports = __webpack_public_path__ + "img/ig.1e920ab5.svg";